import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useField } from 'formik';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  label: {
    fontSize: 16,
    fontWeight: 700,
    color: 'rgba(51,51,51, 0.8)',
    padding: '0 0 5px 0',
  },
  errmsg: {
    color: '#e74c3c',
    fontSize: 12,
    padding: '5px 0 5px 0',
    textAlign: 'right',
    width: '100%',
  },
  descriptionText: {
    fontSize: 12,
    padding: '5px 0 5px 0',
    color: 'rgba(51,51,51,0.6)',
    width: '100%',
    textAlign: 'left',
  },
  input: {
    padding: '10px 18px',
    borderRadius: 6,
    // boxSizing: 'border-box',
    minHeight: 40,
    fontSize: 14,
    border: '1px solid rgba(0, 0, 0, 0.23)',
    '&:focus': {
      outline: 'none',
    },
  },
}));

const FormInput = props => {
  const {
    width,
    height,
    label,
    fieldName,
    formType,
    placeholder,
    textarea,
    disableAutoComplete,
    descriptionText,
    disabled,
    onChange,
  } = props;
  const [field, meta, helpers] = useField(props);
  const classes = useStyles();
  const inputType = formType || 'text';
  return (
    <div
      className={classes.root}
      style={textarea ? { width, marginBottom: 21 } : { width, height }}
    >
      {label ? <div className={classes.label}>{label}</div> : null}
      {textarea ? (
        <textarea
          className={classes.input}
          {...field}
          name={fieldName}
          style={{ height: 100, width }}
          disabled={disabled}
          onChange={e => {
            if (onChange) {
              onChange(e);
            } else {
              helpers.setValue(e.target.value);
            }
          }}
          value={field.value || ''}
        />
      ) : (
        <input
          className={classes.input}
          type={inputType}
          {...field}
          name={fieldName}
          step="any"
          placeholder={placeholder}
          style={{ height: 40, width }}
          autoComplete={disableAutoComplete ? 'new-password' : ''}
          disabled={disabled}
          onChange={e => {
            if (onChange) {
              onChange(e);
            } else {
              helpers.setValue(e.target.value);
            }
          }}
          value={field.value || ''}
        />
      )}
      {descriptionText ? (
        <div className={classes.descriptionText}>{descriptionText}</div>
      ) : null}
      {meta.touched && meta.error ? (
        <div className={classes.errmsg}>{meta.error}</div>
      ) : null}
    </div>
  );
};

FormInput.defaultProps = {
  width: 280,
  height: 85,
  formType: 'text',
  label: '',
  placeholder: 'Input',
  textarea: false,
};

FormInput.propTypes = {
  width: PropTypes.any,
  formType: PropTypes.string,
  label: PropTypes.string,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  textarea: PropTypes.bool,
  disableAutoComplete: PropTypes.bool,
  descriptionText: PropTypes.string,
  disabled: PropTypes.bool,
  height: PropTypes.number,
  name: PropTypes.string.isRequired,
};

export default FormInput;
